import { object, string, number } from 'yup'
import { t } from 'ttag'

import {
  NAME_FIELD,
  LAST_NAME_FIELD,
  ROLE_FIELD,
  ADDRESS_FIELD,
  PASSWORD_FIELD,
} from './model'

export const MAX_NAME_CHARACTERS = 30
export const MAX_LAST_NAME_CHARACTERS = 150
export const MAX_EMAIL_CHARACTERS = 254
export const MAX_PASSWORD_CHARACTERS = 128
export const MIN_PASSWORD_CHARACTERS = 8

const passwordSchema = string()
  .min(
    MIN_PASSWORD_CHARACTERS,
    t`Your password must contain at least ${MIN_PASSWORD_CHARACTERS} characters.`,
  )
  .max(
    MAX_PASSWORD_CHARACTERS,
    t`Name cannot exceed ${MAX_PASSWORD_CHARACTERS} characters.`,
  )
  .matches(/(?!^\d+$)^.+$/g, 'Your password can’t be entirely numeric.')

export const getSchema = isEditMode =>
  object().shape({
    [NAME_FIELD]: string()
      .max(
        MAX_NAME_CHARACTERS,
        t`Name cannot exceed ${MAX_NAME_CHARACTERS} characters.`,
      )
      .required(t`This field cannot be empty.`),
    [LAST_NAME_FIELD]: string().max(
      MAX_LAST_NAME_CHARACTERS,
      t`Name cannot exceed ${MAX_LAST_NAME_CHARACTERS} characters.`,
    ),
    [ROLE_FIELD]: object()
      .shape({ value: number(), label: string() })
      .required(),
    [ADDRESS_FIELD]: string()
      .email()
      .max(
        MAX_EMAIL_CHARACTERS,
        t`Name cannot exceed ${MAX_EMAIL_CHARACTERS} characters.`,
      )
      .required(t`This field cannot be empty.`),
    [PASSWORD_FIELD]: isEditMode
      ? passwordSchema
      : passwordSchema.required(t`This field cannot be empty.`),
  })
